import React from 'react';
import { makeStyles, Paper, Theme } from '@material-ui/core';
import clsx from 'clsx';
import { TimelineScroller, TimelineScrollerProps } from '@moderepo/mode-app-components';



const useStyle = makeStyles((theme: Theme) => {
    return {
        root: {
            padding                     : theme.spacing(1),
            display                     : 'flex',
            flexDirection               : 'column',
            alignItems                  : 'center',
            justifyContent              : 'center',
            minWidth                    : 100,
            [theme.breakpoints.up('sm')]: {
                padding: theme.spacing(1, 2),
            },
        },
    };
}, { name: 'TimelineControlBar' });



export interface TimelineControlBarProps {
    readonly className?: string;
    readonly timelineScrollerProps: TimelineScrollerProps;
}


export const TimelineControlBar = (props: TimelineControlBarProps) => {

    const classes = useStyle();

    return (
        <Paper className={clsx(classes.root, props.className)} elevation={5}>
            <TimelineScroller
                {...props.timelineScrollerProps}
            />
        </Paper>
    );
};
